export default "__VITE_ASSET__i4sP11Ky__"